import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Unprefixed convenience route. Payment providers and users type "/terms"
 * directly; the canonical page lives under a locale prefix, so send them there.
 */
export const Route = createFileRoute("/terms")({
  beforeLoad: () => {
    // 301, not the default 307: this move is permanent, and a temporary redirect
    // leaves the old URL sitting in Search Console as "Page with redirect" for good.
    throw redirect({
      to: "/$lang/terms",
      params: { lang: "en" },
      replace: true,
      statusCode: 301,
    });
  },
  component: () => null,
});
